import { Link } from 'react-router-dom';
import { useT } from '@dia/i18n';

/** Every screen below the home page starts with a way back to it. */
export function BackLink({ to = '/', label }: { to?: string; label?: string }) {
  const { t } = useT();
  return (
    <Link
      to={to}
      className="inline-flex items-center min-h-tap text-accent underline underline-offset-4 mb-2"
    >
      {'‹'} {label ?? t('guest.nav.stay')}
    </Link>
  );
}
